// @ts-nocheck — migrated from JS; reactstrap / react-select / layout prop friction.
import React, { Fragment, useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { useForm } from "react-hook-form";
import { Colxx, Separator } from "Components/CustomBootstrap";
import BreadcrumbContainer from "Components/BreadcrumbContainer";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  Input,
  CardTitle,
  FormGroup,
  Label,
  Button,
  Form,
  CardSubtitle
} from "reactstrap";
import Select from "react-select";
import CustomSelect from "Components/CustomSelect";
import DatePicker from "react-datepicker";
import moment from "moment";
import TagsInput from "react-tagsinput";
import "react-tagsinput/react-tagsinput.css";
import "react-datepicker/dist/react-datepicker.css";
import "rc-switch/assets/index.css";
import "rc-slider/assets/index.css";
import "react-rater/lib/react-rater.css";
import "react-fine-uploader/gallery/gallery.css";

const selectGender = [
  { label: "Male", value: "male", key: 0 },
  { label: "Female", value: "female", key: 1 }
];

function ValidationFormPrimary() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const {
    ref: usernameFieldRef,
    ...usernameFieldRest
  } = register("usernameField", { required: true });
  const {
    ref: passwordFieldRef,
    ...passwordFieldRest
  } = register("passwordField", { required: true });

  return (
    <Form className="mb-5 row" onSubmit={handleSubmit(() => {})}>
      <Colxx sm={6}>
        <FormGroup>
          <Label className="av-label" for="aveUserName">
            <IntlMessages id="forms.username" />
          </Label>
          <Input
            id="aveUserName"
            invalid={!!errors.usernameField}
            innerRef={usernameFieldRef}
            {...usernameFieldRest}
          />
          {errors.usernameField && (
            <div className="invalid-feedback d-block">
              <IntlMessages id="forms.username-required" />
            </div>
          )}
        </FormGroup>
      </Colxx>

      <Colxx sm={6}>
        <FormGroup>
          <Label className="av-label" for="avePassword">
            <IntlMessages id="forms.password" />
          </Label>
          <Input
            id="avePassword"
            type="password"
            invalid={!!errors.passwordField}
            innerRef={passwordFieldRef}
            {...passwordFieldRest}
          />
          {errors.passwordField && (
            <div className="invalid-feedback d-block">
              <IntlMessages id="forms.password-required" />
            </div>
          )}
        </FormGroup>
      </Colxx>

      <Colxx sm={12}>
        <FormGroup>
          <Button outline color="primary" type="submit">
            <IntlMessages id="forms.login" />
          </Button>
        </FormGroup>
      </Colxx>
    </Form>
  );
}

function ValidationFormTooltip() {
  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm();

  const { ref: tooltipUserRef, ...tooltipUserRest } = register("tooltipUser", {
    required: true
  });
  const { ref: tooltipPassRef, ...tooltipPassRest } = register("tooltipPass", {
    required: true
  });

  return (
    <Form className="av-tooltip mb-5 row" onSubmit={handleSubmit(() => {})}>
      <Colxx sm={6}>
        <FormGroup>
          <Label className="av-label" for="TooltipUsername">
            <IntlMessages id="forms.username" />
          </Label>
          <Input
            id="TooltipUsername"
            invalid={!!errors.tooltipUser}
            innerRef={tooltipUserRef}
            {...tooltipUserRest}
          />
          {errors.tooltipUser && (
            <div className="invalid-feedback d-block">
              <IntlMessages id="forms.username-required" />
            </div>
          )}
        </FormGroup>
      </Colxx>

      <Colxx sm={6}>
        <FormGroup>
          <Label className="av-label" for="PasswordTooltip">
            <IntlMessages id="forms.password" />
          </Label>
          <Input
            id="PasswordTooltip"
            type="password"
            invalid={!!errors.tooltipPass}
            innerRef={tooltipPassRef}
            {...tooltipPassRest}
          />
          {errors.tooltipPass && (
            <div className="invalid-feedback d-block">
              <IntlMessages id="forms.password-required" />
            </div>
          )}
        </FormGroup>
      </Colxx>

      <Colxx sm={12}>
        <FormGroup>
          <Button outline color="primary" type="submit">
            <IntlMessages id="forms.login" />
          </Button>
        </FormGroup>
      </Colxx>
    </Form>
  );
}

function FormsValidationSection() {
  return (
    <>
      <ValidationFormPrimary />
      <CardSubtitle>Validations Form</CardSubtitle>
      <ValidationFormTooltip />
    </>
  );
}

function Forms() {
  const { messages } = useIntl();
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedOptionLO, setSelectedOptionLO] = useState("");
  const [selectedOptionLabelTop, setSelectedOptionLabelTop] = useState("");
  const [startDate, setStartDate] = useState(null);
  const [startDateLO, setStartDateLO] = useState(null);
  const [startDateLT, setStartDateLT] = useState(null);
  const [startDateTime, setStartDateTime] = useState(null);
  const [startDateRange, setStartDateRange] = useState(null);
  const [endDateRange, setEndDateRange] = useState(null);
  const [embeddedDate, setEmbeddedDate] = useState(() => moment());
  const [tags, setTags] = useState([]);
  const [tagsLabelOver, setTagsLabelOver] = useState([]);
  const [tagsLabelTop, setTagsLabelTop] = useState([]);

  const handleTagChange = useCallback(t => setTags(t), []);
  const handleTagChangeLO = useCallback(t => setTagsLabelOver(t), []);
  const handleTagsLabelTopChange = useCallback(t => setTagsLabelTop(t), []);
  const handleChangeLO = useCallback(v => setSelectedOptionLO(v), []);
  const handleChangeLT = useCallback(v => setSelectedOptionLabelTop(v), []);
  const handleChangeDateLO = useCallback(d => setStartDateLO(d), []);
  const handleChangeDateLT = useCallback(d => setStartDateLT(d), []);

  return (
    <Fragment>
        <Row>
          <Colxx lg="6" xxs="12">
            <BreadcrumbContainer heading={<IntlMessages id="menu.forms" />} />
            <Separator className="mb-5" />
          </Colxx>
        </Row>

        {/* Inline Form */}
        <Row className="mb-4">
          <Colxx lg="12">
            <Card>
              <CardBody>
                <CardTitle>
                  <IntlMessages id="forms-inline" />
                </CardTitle>
                <Form className="d-flex flex-wrap align-items-center gap-2">
                  <FormGroup>
                    <Label for="exampleEmail" hidden>
                      Email
                    </Label>
                    <Input
                      type="email"
                      name="email"
                      id="exampleEmail"
                      placeholder="Email"
                      className="me-2"
                    />
                  </FormGroup>{" "}
                  <FormGroup>
                    <Label for="examplePassword" hidden>
                      Password
                    </Label>
                    <Input
                      type="password"
                      name="password"
                      id="examplePassword"
                      placeholder="Password"
                      className="me-2"
                    />
                  </FormGroup>{" "}
                  <Button color="primary" className="my-2">
                    Login
                  </Button>
                </Form>

                {/* Form inline type two */}
                <div className="mt-3">
                  <Form className="d-flex flex-wrap align-items-center gap-2">
                    <FormGroup className="mb-2 me-sm-2 mb-sm-0 mt-2">
                      <Label for="exampleEmail" className="me-sm-2">
                        Email
                      </Label>
                      <Input
                        type="email"
                        name="email"
                        id="exampleEmail"
                        placeholder="you@domain.com"
                      />
                    </FormGroup>
                    <FormGroup className="mb-2 me-sm-2 mb-sm-0 mt-2">
                      <Label for="examplePassword" className="me-sm-2">
                        Password
                      </Label>
                      <Input
                        type="password"
                        name="password"
                        id="examplePassword"
                        placeholder="Please enter the password"
                      />
                    </FormGroup>
                    <Button color="primary" className="mt-2">
                      Login
                    </Button>
                  </Form>
                </div>
                {/* Form inline type two ends hee */}
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        {/* Inline Form */}
        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <CardTitle>
                  <p>Login Form</p>
                </CardTitle>
                <Form>
                  <FormGroup>
                    <Label for="yourEmail">Email :</Label>
                    <Input
                      type="email"
                      name="email"
                      id="yourEmail"
                      placeholder="Your email.."
                    />
                  </FormGroup>

                  <FormGroup>
                    <Label for="yourPassword">Password :</Label>
                    <Input
                      type="password"
                      name="yourPassword"
                      id="yourPassword"
                      placeholder="Your password..."
                    />
                  </FormGroup>

                  <FormGroup check>
                    <Input type="checkbox" id="agreeCheckbox" />
                    <Label for="agreeCheckbox" check>
                      Agree to terms
                    </Label>
                  </FormGroup>

                  <Button color="primary" className="mt-4">
                    Login
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <CardTitle>
                  <p>Register Form</p>
                </CardTitle>
                <Form>
                  <Row>
                    <Colxx md={6}>
                      <FormGroup>
                        <Label for="exampleEmail">Email</Label>
                        <Input
                          type="email"
                          name="email"
                          id="exampleEmail"
                          placeholder="with a placeholder"
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx md={6}>
                      <FormGroup>
                        <Label for="examplePassword">Password</Label>
                        <Input
                          type="password"
                          name="password"
                          id="examplePassword"
                          placeholder="password placeholder"
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>
                  <FormGroup>
                    <Label for="exampleAddress">Address</Label>
                    <Input
                      type="text"
                      name="address"
                      id="exampleAddress"
                      placeholder="1234 Main St"
                    />
                  </FormGroup>
                  <FormGroup>
                    <Label for="exampleAddress2">Address 2</Label>
                    <Input
                      type="text"
                      name="address2"
                      id="exampleAddress2"
                      placeholder="Apartment, studio, or floor"
                    />
                  </FormGroup>
                  <Row>
                    <Colxx md={6}>
                      <FormGroup>
                        <Label for="exampleCity">City</Label>
                        <Input type="text" name="city" id="exampleCity" />
                      </FormGroup>
                    </Colxx>
                    <Colxx md={4}>
                      <FormGroup>
                        <Label for="exampleState">State</Label>
                        <Input type="text" name="state" id="exampleState" />
                      </FormGroup>
                    </Colxx>
                    <Colxx md={2}>
                      <FormGroup>
                        <Label for="exampleZip">Zip</Label>
                        <Input type="text" name="zip" id="exampleZip" />
                      </FormGroup>
                    </Colxx>
                    <Colxx lg={4}>
                      <FormGroup>
                        <Label for="exampleZip">Add Skills</Label>
                        <TagsInput
                          value={tagsLabelOver}
                          onChange={handleTagChangeLO}
                          inputProps={{ placeholder: messages["forms.tags"] }}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx lg={4}>
                      <FormGroup>
                        <Label for="exampleZip">DOB</Label>
                        <DatePicker
                          selected={startDateLO}
                          onChange={handleChangeDateLO}
                        />
                      </FormGroup>
                    </Colxx>
                    <Colxx lg={4}>
                      <FormGroup>
                        <label>Choose Gender</label>
                        <Select
                          components={{ Input: CustomSelect }}
                          className="react-select"
                          classNamePrefix="react-select"
                          name="form-field-name"
                          value={selectedOptionLO}
                          onChange={handleChangeLO}
                          options={selectGender}
                        />
                      </FormGroup>
                    </Colxx>
                  </Row>
                  <FormGroup check>
                    <Input type="checkbox" name="check" id="exampleCheck" />
                    <Label for="exampleCheck" check>
                      Agree to Terms
                    </Label>
                  </FormGroup>
                  <Button color="primary" className="mt-2">
                    Register
                  </Button>
                </Form>
              </CardBody>
            </Card>
          </Colxx>
        </Row>

        <Row className="mb-4">
          <Colxx xxs="12">
            <Card>
              <CardBody>
                <CardTitle>Form With Validation</CardTitle>

                <FormsValidationSection />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
  );
}
export default Forms;
